import RewardsAndRecognition from './views/RewardsAndRecognition'

export default RewardsAndRecognition